import classNames from "classnames";
import React from "react";
import styles from "./signUpCheckbox.css";

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  hasError?: boolean;
  error?: string;
}

export const SignUpCheckbox: React.SFC<Props> = ({
  checked,
  onChange,
  hasError,
  children,
  error
}) => {
  return (
    <div className={classNames(styles.wrapper, { [styles["has-error"]]: hasError })}>
      <label>
        <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
        <span>{children}</span>
      </label>
      <div className={styles["error-message"]}>{hasError && error}</div>
    </div>
  );
};
